module.exports = __webpack_public_path__ + "static/img/typeTwo.723ba4f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/haierProduct/images/typeTwo.jpg
// module id = uyYR
// module chunks = 4